// Transaction status constants
export const TransactionStatus = Object.freeze({
  INITIATED: "INITIATED",
  FAIL: "FAIL",
  WAIT_PAY: "WAIT_PAY",
  EXPIRED: "EXPIRED",
  PAY_SUCCESS: "PAY_SUCCESS",
  PAY_FAIL: "PAY_FAIL",
  WAIT_REFUND: "WAIT_REFUND",
  REFUND_SUCCESS: "REFUND_SUCCESS",
  REFUND_FAIL: "REFUND_FAIL",
  CLOSED: "CLOSED",
});

// Payment method constants
export const PaymentMethod = Object.freeze({
  QR_CODE: "PAY_BY_QRCODE",
  MMQR: "mmqr"

});

// Payment operators that render in-app (no external redirect)
export const IN_APP_OPERATORS = Object.freeze([
  "AYAPay",
  "MPU",
  "JCB",
  "Visa",
  "Master",
  "UnionPay",
  "uabpay",
  "MMQR",
]);

// Special operator that uses KPay component
export const QR_OPERATORS = Object.freeze({
  KBZPAY: "KBZPay",
});

// Terminal transaction statuses (payment failed/expired)
export const TERMINAL_STATUSES = Object.freeze([
  TransactionStatus.FAIL,
  TransactionStatus.EXPIRED,
  TransactionStatus.PAY_FAIL,
  TransactionStatus.REFUND_FAIL,
  TransactionStatus.CLOSED,
]);

// Supported languages
export const SUPPORTED_LANGUAGES = Object.freeze(["en", "mm", "ch"]);

// Default values
export const DEFAULT_LANG = "en";
export const DEFAULT_LOADING_DURATION = 2500;
export const EXTRA_LOADING_TIMEOUT = 3000;
export const POLL_INTERVAL = 3000;
export const RETRY_INTERVAL = 3000;

// Error messages
export const ERROR_MESSAGES = Object.freeze({
  NO_ORDER_ID: "No orderId found in URL",
  INVALID_RESPONSE: "Invalid response from server",
  FETCH_FAILED: "Failed to fetch redirect info",
  PAYMENT_FAILED: "Your payment could not be finalized. No charge has been applied to your account.",
});